

















import { defineComponent } from "@vue/composition-api";
import { MoneyParts } from "@scrile/tools/dist/lib/MoneyHelpers";
import { formatMoney, formatMoneyString } from "@/lib/moneyHelpers";

export default defineComponent({
  name: "FormatMoney",
  props: {
    cost: { type: Number, required: true },
    fontSize: { type: Number },
    forceNumberSymbol: { type: Boolean as () => boolean | undefined },
    currencyCode: { type: String as () => string | undefined },
  },
  computed: {
    moneyParts(): MoneyParts {
      return formatMoney(this.cost, { currencyCode: this.currencyCode, forceNumberSymbol: this.forceNumberSymbol });
    },

    formattedString(): string {
      return formatMoneyString(this.cost, {
        currencyCode: this.currencyCode,
        forceNumberSymbol: this.forceNumberSymbol,
      });
    },

    separator(): string {
      return this.moneyParts.separator;
    },

    numberSymbol(): string {
      return this.moneyParts.numberSymbol;
    },

    symbol(): string {
      return this.moneyParts.symbol;
    },

    costString(): string[] {
      return [this.moneyParts.wholePart, this.moneyParts.fractionalPart];
    },
  },
});
